import axios from 'axios';
import { ProjectConfig } from 'Global';

// Tipo para los labels
export interface Labels {
  home?: {
    santo_del_dia?: string;
    liturgia_horas?: string;
    misa_del_dia?: string;
    propios?: string;
    santoral?: string;
    calendario_liturgico?: string;
    oraciones?: string;
    celebraciones?: string;
    aniversarios?: string;
    maximas?: string;
    multimedia?: string;
    constituciones?: string;
    directorio?: string;
    acuerdos_capitulares?: string;
    ano_liturgico?: string;
    ritos?: string;
    cuenta?: string;
    cerrar_sesion?: string;
  };
  santoral?: {
    santoral_titulo?: string;
    santos_titulo?: string;
    biografia?: string;
    oraciones_del_santo?: string;
    calendario_propio_hsf?: string;
    primeras_visperas?: string;
    oficio_lectura?: string;
    laudes?: string;
    horas_intermedias?: string;
    visperas?: string;
    completas?: string;
    lecturas?: string;
    calendario_romano_general?: string;
    calendario_romano_descripcion?: string;
    martirologio_romano?: string;
    martirologio_descripcion?: string;
    martirologio_catalogo_pendiente?: string;
    martirologio_catalogo_nota?: string;
    estado_verificacion?: string;
    verificado_2026?: string;
    en_verificacion_2026?: string;
    martirologio_no_disponible?: string;
    martirologio_edicion?: string;
    buscar_por_nombre?: string;
    sin_resultados?: string;
    fecha?: string;
    condicion?: string;
    lugar?: string;
    epoca?: string;
    fuente?: string;
    ver_catalogo_completo?: string;
    santos_y_beatos?: string;
  };
  aniversarios?: {
    aniversarios_titulo?: string;
    nacimiento?: string;
    fallecimiento?: string;
    ordenacion_sacerdotal?: string;
    profesion_religiosa?: string;
    onomastica?: string;
    biografia?: string;
    cumpleanos?: string;
    profesion?: string;
    ordenacion?: string;
    defuncion?: string;
  };
  fiestas?: {
    fiestas_titulo?: string;
    propios_titulo?: string;
    primeras_visperas?: string;
    oficio_lectura?: string;
    laudes?: string;
    horas_intermedias?: string;
    visperas?: string;
    completas?: string;
    lecturas?: string;
    [key: string]: string | undefined;
  };
  maximas?: {
    maximas_titulo?: string;
  };
  oraciones?: {
    oraciones_titulo?: string;
  };
  multimedia?: {
    multimedia_titulo?: string;
  };
  acuerdos?: {
    acuerdos_titulo?: string;
  };
  directorio?: {
    directorio_titulo?: string;
  };
  celebraciones?: {
    celebraciones_titulo?: string;
  };
  constituciones: {
    constituciones_titulo?: string;
  };
  sistema: {
    atras?: string;
    hoy?: string;
    siguiente?: string;
  };
  calendario_liturgico: {
    calendario_liturgico_titulo?: string;
    liturgia_horas_titulo?: string;
    misa_del_dia_titulo?: string;
    ir_a_lecturas?: string;
    // Secciones de la misa
    lectura?: string;
    lectio_divina?: string;
    reflexiones?: string;
    // Categorías
    oficio_lectura?: string;
    laudes?: string;
    horas_intermedias?: string;
    visperas?: string;
    completas?: string;
    // Días de la semana
    domingo?: string;
    lunes?: string;
    martes?: string;
    miercoles?: string;
    jueves?: string;
    viernes?: string;
    sabado?: string;
    // Tiempos litúrgicos
    tiempo_ordinario?: string;
    adviento?: string;
    navidad?: string;
    cuaresma?: string;
    semana_santa?: string;
    pascua?: string;
    // Meses del año
    enero?: string;
    febrero?: string;
    marzo?: string;
    abril?: string;
    mayo?: string;
    junio?: string;
    julio?: string;
    agosto?: string;
    septiembre?: string;
    octubre?: string;
    noviembre?: string;
    diciembre?: string;
    // Otros
    semana?: string;
    de?: string;
    del?: string;
    hoy?: string;
    fiesta_propia?: string;
    // Colores litúrgicos
    color_blanco?: string;
    color_rojo?: string;
    color_verde?: string;
    color_morado?: string;
    color_rosa?: string;
    color_negro?: string;
    color_dorado?: string;
  };
  // Agregar más módulos aquí según se necesiten
}

// Labels por defecto en español
export const DEFAULT_LABELS: Labels = {
  home: {
    santo_del_dia: 'Santo del día',
    liturgia_horas: 'Liturgia de las horas',
    misa_del_dia: 'Misa del día',
    propios: 'Comunes',
    santoral: 'Santoral',
    calendario_liturgico: 'Calendario litúrgico',
    oraciones: 'Oraciones',
    celebraciones: 'Celebraciones',
    aniversarios: 'Aniversarios',
    maximas: 'Máximas',
    multimedia: 'Multimedia',
    constituciones: 'Constituciones',
    directorio: 'Directorio',
    acuerdos_capitulares: 'Acuerdos capitulares',
    ano_liturgico: 'Año litúrgico',
    ritos: 'Ritos',
    cuenta: 'Cuenta',
    cerrar_sesion: 'Cerrar sesión',
  },
  santoral: {
    santoral_titulo: 'Santoral',
    santos_titulo: 'Santos',
    biografia: 'BIOGRAFÍA',
    oraciones_del_santo: 'ORACIONES DEL SANTO',
    calendario_propio_hsf: 'CALENDARIO PROPIO HSF',
    primeras_visperas: 'PRIMERAS VÍSPERAS',
    oficio_lectura: 'OFICIO DE LECTURA',
    laudes: 'LAUDES',
    horas_intermedias: 'HORAS INTERMEDIAS',
    visperas: 'VÍSPERAS',
    completas: 'COMPLETAS',
    lecturas: 'LECTURAS DE LA MISA',
    calendario_romano_general: 'Calendario Romano General',
    calendario_romano_descripcion: 'Celebraciones del calendario universal de la Iglesia.',
    martirologio_romano: 'Martirologio Romano',
    martirologio_descripcion: 'Catálogo estructural del Martirologio Romano.',
    martirologio_catalogo_pendiente: 'El catálogo estructural de la edición 2026 está preparado, pero permanecerá cerrado hasta certificar el censo completo de esa edición.',
    martirologio_catalogo_nota: 'Catálogo consultable en reconstrucción de la edición 2026. Las fechas solo se muestran cuando están certificadas.',
    estado_verificacion: 'Estado',
    verificado_2026: 'Verificado en la edición 2026',
    en_verificacion_2026: 'En verificación estructural 2026',
    martirologio_no_disponible: 'El catálogo del Martirologio Romano no está disponible.',
    martirologio_edicion: 'Edición',
    buscar_por_nombre: 'Buscar por nombre',
    sin_resultados: 'No se encontraron resultados.',
    fecha: 'Fecha',
    condicion: 'Condición',
    lugar: 'Lugar',
    epoca: 'Época',
    fuente: 'Fuente',
    ver_catalogo_completo: 'Ver catálogo completo',
    santos_y_beatos: 'Santos y beatos',
  },
  aniversarios: {
    aniversarios_titulo: 'Aniversarios',
    nacimiento: 'Nacimiento',
    fallecimiento: 'Fallecimiento',
    ordenacion_sacerdotal: 'Ordenación sacerdotal',
    profesion_religiosa: 'Profesión religiosa',
    onomastica: 'Onomástica',
    biografia: 'Biografía',
    cumpleanos: 'CUMPLEAÑOS',
    profesion: 'PROFESIÓN',
    ordenacion: 'ORDENACIÓN',
    defuncion: 'DEFUNCIÓN',
  },
  fiestas: {
    fiestas_titulo: 'Comunes',
    propios_titulo: 'Comunes',
    primeras_visperas: 'PRIMERAS VÍSPERAS',
    oficio_lectura: 'OFICIO DE LECTURA',
    laudes: 'LAUDES',
    horas_intermedias: 'HORAS INTERMEDIAS',
    visperas: 'VÍSPERAS',
    completas: 'COMPLETAS',
    lecturas: 'LECTURAS DE LA MISA',
    structured_option: "Opción",
    structured_official_variants: "Variantes litúrgicas oficiales",
    common_variant_default: "Texto general del común",
    structured_mass: "Misa",
    structured_entrance_antiphon: "Antífona de entrada",
    structured_collect: "Oración colecta",
    structured_prayer_over_offerings: "Oración sobre las ofrendas",
    structured_preface: "Prefacio",
    structured_communion_antiphon: "Antífona de comunión",
    structured_prayer_after_communion: "Oración después de la comunión",
    structured_lectionary: "Leccionario",
    structured_first_reading: "Primera lectura",
    structured_responsorial_psalm: "Salmo responsorial",
    structured_second_reading: "Segunda lectura",
    structured_gospel_acclamation: "Aclamación antes del Evangelio",
    structured_gospel: "Evangelio",
    structured_liturgy_of_hours: "Liturgia de las Horas",
    structured_first_vespers: "Primeras vísperas",
    structured_office_of_readings: "Oficio de lectura",
    structured_lauds: "Laudes",
    structured_midday_prayer: "Hora intermedia",
    structured_vespers: "Vísperas",
    common_variant_dedicated_church: "En la iglesia cuya dedicación se celebra",
    common_variant_outside_dedicated_church: "Fuera de la iglesia dedicada",
    common_variant_ordinary_time: "Tiempo Ordinario",
    common_variant_advent: "Tiempo de Adviento",
    common_variant_christmas: "Tiempo de Navidad",
    common_variant_easter: "Tiempo Pascual",
    common_variant_outside_easter_several_martyrs: "Fuera del tiempo pascual — Para varios mártires",
    common_variant_outside_easter_one_martyr: "Fuera del tiempo pascual — Para un mártir",
    common_variant_easter_several_martyrs: "Tiempo pascual — Para varios mártires",
    common_variant_easter_one_martyr: "Tiempo pascual — Para un mártir",
    common_variant_missionary_several_martyrs: "Para los misioneros mártires — Para varios misioneros mártires",
    common_variant_missionary_one_martyr: "Para los misioneros mártires — Para un misionero mártir",
    common_variant_virgin_martyr: "Para una virgen mártir",
    common_variant_holy_woman_martyr: "Para una santa mujer mártir",
    common_variant_pope_or_bishop: "Para un Papa o para un obispo",
    common_variant_bishop: "Para un obispo",
    common_variant_several_pastors: "Para los pastores — Para varios pastores",
    common_variant_one_pastor: "Para los pastores — Para un pastor",
    common_variant_one_founder: "Para los fundadores de las Iglesias — Para un fundador",
    common_variant_several_founders: "Para los fundadores de las Iglesias — Para varios fundadores",
    common_variant_missionaries: "Para los misioneros",
    common_variant_several_virgins: "Para varias vírgenes",
    common_variant_one_virgin: "Para una virgen",
    common_variant_all_saints_several: "Para toda clase de santos — Para varios santos",
    common_variant_all_saints_one: "Para toda clase de santos — Para un santo",
    common_variant_abbot: "Para los monjes y los religiosos — Para un abad",
    common_variant_monk: "Para los monjes y los religiosos — Para un monje",
    common_variant_nun: "Para los monjes y los religiosos — Para una monja",
    common_variant_religious: "Para los monjes y los religiosos — Para los religiosos",
    common_variant_works_of_mercy: "Para los que hicieron obras de misericordia",
    common_variant_educators: "Para los educadores",
    common_variant_holy_women: "Para las santas mujeres",
    common_variant_several_martyrs: "Para varios mártires",
    common_variant_one_martyr: "Para un mártir",
    common_variant_all_saints: "Para toda clase de santos",
    common_variant_monks_religious: "Para los monjes y los religiosos",
  },
  maximas: {
    maximas_titulo: 'Máximas',
  },
  oraciones: {
    oraciones_titulo: 'Oraciones',
  },
  multimedia: {
    multimedia_titulo: 'Multimedia',
  },
  acuerdos: {
    acuerdos_titulo: 'Acuerdos',
  },
  directorio: {
    directorio_titulo: 'Directorio',
  },
  celebraciones: {
    celebraciones_titulo: 'Celebraciones',
  },
  constituciones: {
    constituciones_titulo: 'Constituciones',
  },
  sistema: {
    atras: 'Atrás',
    hoy: 'Hoy',
    siguiente: 'Siguiente',
  },
  calendario_liturgico: {
    calendario_liturgico_titulo: 'Calendario litúrgico',
    liturgia_horas_titulo: 'Liturgia de las horas',
    misa_del_dia_titulo: 'Misa del día',
    ir_a_lecturas: 'Ir a lecturas',
    // Secciones de la misa
    lectura: 'Lectura',
    lectio_divina: 'Lectio divina',
    reflexiones: 'Reflexiones',
    // Categorías
    oficio_lectura: 'Oficio de lectura',
    laudes: 'Laudes',
    horas_intermedias: 'Horas intermedias',
    visperas: 'Vísperas',
    completas: 'Completas',
    // Días de la semana
    domingo: 'Domingo',
    lunes: 'Lunes',
    martes: 'Martes',
    miercoles: 'Miércoles',
    jueves: 'Jueves',
    viernes: 'Viernes',
    sabado: 'Sábado',
    // Tiempos litúrgicos
    tiempo_ordinario: 'Tiempo ordinario',
    adviento: 'Adviento',
    navidad: 'Navidad',
    cuaresma: 'Cuaresma',
    semana_santa: 'Semana Santa',
    pascua: 'Pascua',
    // Meses del año
    enero: 'Enero',
    febrero: 'Febrero',
    marzo: 'Marzo',
    abril: 'Abril',
    mayo: 'Mayo',
    junio: 'Junio',
    julio: 'Julio',
    agosto: 'Agosto',
    septiembre: 'Septiembre',
    octubre: 'Octubre',
    noviembre: 'Noviembre',
    diciembre: 'Diciembre',
    // Otros
    semana: 'Semana',
    de: 'de',
    del: 'del',
    hoy: 'Hoy',
    fiesta_propia: 'Fiesta propia',
    // Colores litúrgicos
    color_blanco: 'Blanco',
    color_rojo: 'Rojo',
    color_verde: 'Verde',
    color_morado: 'Morado',
    color_rosa: 'Rosa',
    color_negro: 'Negro',
    color_dorado: 'Dorado',
  }
};

const SANTORAL_NAV_LABELS_BY_LANG_ID: Record<string, Record<string, string>> = {
  "1": {
    santoral_titulo: "Santoral",
    calendario_romano_general: "Calendario Romano General",
    calendario_romano_descripcion: "Celebraciones del calendario universal de la Iglesia.",
    martirologio_romano: "Martirologio Romano",
    martirologio_descripcion: "Catálogo estructural del Martirologio Romano.",
    martirologio_catalogo_pendiente: "El catálogo estructural de la edición 2026 está preparado, pero permanecerá cerrado hasta certificar el censo completo de esa edición.",
    martirologio_no_disponible: "El catálogo del Martirologio Romano no está disponible.",
    martirologio_catalogo_nota: "Catálogo consultable en reconstrucción de la edición 2026. Las fechas solo se muestran cuando están certificadas.",
    estado_verificacion: "Estado",
    verificado_2026: "Verificado en la edición 2026",
    en_verificacion_2026: "En verificación estructural 2026",
    martirologio_edicion: "Edición",
    buscar_por_nombre: "Buscar por nombre",
    sin_resultados: "No se encontraron resultados.",
    fecha: "Fecha",
    condicion: "Condición",
    lugar: "Lugar",
    epoca: "Época",
    fuente: "Fuente",
    ver_catalogo_completo: "Ver catálogo completo",
    santos_y_beatos: "Santos y beatos",
  },
  "4": {
    santoral_titulo: "Calendar of Saints",
    calendario_romano_general: "General Roman Calendar",
    calendario_romano_descripcion: "Celebrations of the universal calendar of the Church.",
    martirologio_romano: "Roman Martyrology",
    martirologio_descripcion: "Saints and blesseds inscribed in the Roman Martyrology.",
    martirologio_catalogo_pendiente: "The structural catalogue for the 2026 edition is prepared, but it will remain closed until the complete census of that edition is certified.",
    martirologio_no_disponible: "The Roman Martyrology catalogue is not available.",
    martirologio_catalogo_nota: "Browseable 2026 reconstruction. Dates are shown only when certified.",
    martirologio_edicion: "Edition",
    buscar_por_nombre: "Search by name",
    sin_resultados: "No results found.",
    fecha: "Date",
    condicion: "Status",
    lugar: "Place",
    epoca: "Period",
    fuente: "Source",
    ver_catalogo_completo: "View complete catalogue",
    santos_y_beatos: "Saints and blesseds",
  },
  "5": {
    santoral_titulo: "Santorale",
    calendario_romano_general: "Calendario Romano Generale",
    calendario_romano_descripcion: "Celebrazioni del calendario universale della Chiesa.",
    martirologio_romano: "Martirologio Romano",
    martirologio_descripcion: "Catalogo strutturale del Martirologio Romano.",
    martirologio_catalogo_pendiente: "Il catalogo strutturale dell'edizione 2026 è predisposto, ma resterà chiuso finché non sarà certificato il censimento completo dell'edizione.",
    martirologio_no_disponible: "Il catalogo del Martirologio Romano non è disponibile.",
    martirologio_catalogo_nota: "Catalogo consultabile in ricostruzione dell'edizione 2026. Le date sono mostrate solo quando certificate.",
    estado_verificacion: "Stato",
    verificado_2026: "Verificato nell'edizione 2026",
    en_verificacion_2026: "In verifica strutturale 2026",
    martirologio_edicion: "Edizione",
    buscar_por_nombre: "Cerca per nome",
    sin_resultados: "Nessun risultato trovato.",
    fecha: "Data",
    condicion: "Condizione",
    lugar: "Luogo",
    epoca: "Epoca",
    fuente: "Fonte",
    ver_catalogo_completo: "Vedi catalogo completo",
    santos_y_beatos: "Santi e beati",
  },
  "6": {
    santoral_titulo: "Santoral",
    calendario_romano_general: "Calendário Romano Geral",
    calendario_romano_descripcion: "Celebrações do calendário universal da Igreja.",
    martirologio_romano: "Martirológio Romano",
    martirologio_descripcion: "Santos e beatos inscritos no Martirológio Romano.",
    martirologio_catalogo_pendiente: "O catálogo estrutural da edição de 2026 está preparado, mas permanecerá fechado até que o censo completo dessa edição seja certificado.",
    martirologio_no_disponible: "O catálogo do Martirológio Romano não está disponível.",
    martirologio_catalogo_nota: "Catálogo consultável em reconstrução da edição de 2026. As datas só são exibidas quando certificadas.",
    martirologio_edicion: "Edição",
    buscar_por_nombre: "Buscar por nome",
    sin_resultados: "Nenhum resultado encontrado.",
    fecha: "Data",
    condicion: "Condição",
    lugar: "Lugar",
    epoca: "Época",
    fuente: "Fonte",
    ver_catalogo_completo: "Ver catálogo completo",
    santos_y_beatos: "Santos e beatos",
  },
  "7": {
    santoral_titulo: "Calendrier des saints",
    calendario_romano_general: "Calendrier romain général",
    calendario_romano_descripcion: "Célébrations du calendrier universel de l'Église.",
    martirologio_romano: "Martyrologe romain",
    martirologio_descripcion: "Catalogue structurel du Martyrologe romain.",
    martirologio_catalogo_pendiente: "Le catalogue structurel de l'édition 2026 est prêt, mais restera fermé jusqu'à la certification du recensement complet de cette édition.",
    martirologio_no_disponible: "Le catalogue du Martyrologe romain n'est pas disponible.",
    martirologio_catalogo_nota: "Catalogue consultable en reconstruction de l'édition 2026. Les dates ne sont affichées que lorsqu'elles sont certifiées.",
    estado_verificacion: "Statut",
    verificado_2026: "Vérifié dans l'édition 2026",
    en_verificacion_2026: "En vérification structurelle 2026",
    martirologio_edicion: "Édition",
    buscar_por_nombre: "Rechercher par nom",
    sin_resultados: "Aucun résultat.",
    fecha: "Date",
    condicion: "Condition",
    lugar: "Lieu",
    epoca: "Époque",
    fuente: "Source",
    ver_catalogo_completo: "Voir le catalogue complet",
    santos_y_beatos: "Saints et bienheureux",
  },
  "10": {
    santoral_titulo: "Sanctorale",
    calendario_romano_general: "Calendarium Romanum Generale",
    calendario_romano_descripcion: "Celebrationes calendarii universalis Ecclesiae.",
    martirologio_romano: "Martyrologium Romanum",
    martirologio_descripcion: "Catalogus structuralis Martyrologii Romani.",
    martirologio_catalogo_pendiente: "Catalogus structuralis editionis anni 2026 paratus est, sed clausus manebit donec census integer eiusdem editionis certificetur.",
    martirologio_no_disponible: "Catalogus Martyrologii Romani praesto non est.",
    martirologio_catalogo_nota: "Catalogus editionis 2026 reconstruendus et consultabilis. Dies tantum ostenduntur cum certificati sunt.",
    estado_verificacion: "Status",
    verificado_2026: "In editione 2026 verificatum",
    en_verificacion_2026: "Sub verificatione structurali 2026",
    martirologio_edicion: "Editio",
    buscar_por_nombre: "Quaerere nomine",
    sin_resultados: "Nulla inventa sunt.",
    fecha: "Dies",
    condicion: "Conditio",
    lugar: "Locus",
    epoca: "Aetas",
    fuente: "Fons",
    ver_catalogo_completo: "Catalogum integrum videre",
    santos_y_beatos: "Sancti et beati",
  },
  "9": {
    santoral_titulo: "Santoral",
    calendario_romano_general: "Calendari Romà General",
    calendario_romano_descripcion: "Celebracions del calendari universal de l'Església.",
    martirologio_romano: "Martirologi Romà",
    martirologio_descripcion: "Catàleg estructural del Martirologi Romà.",
    martirologio_catalogo_pendiente: "El catàleg estructural de l'edició 2026 està preparat, però romandrà tancat fins que se'n certifiqui el cens complet.",
    martirologio_no_disponible: "El catàleg del Martirologi Romà no està disponible.",
    martirologio_catalogo_nota: "Catàleg consultable en reconstrucció de l'edició 2026. Les dates només es mostren quan estan certificades.",
    estado_verificacion: "Estat",
    verificado_2026: "Verificat a l'edició 2026",
    en_verificacion_2026: "En verificació estructural 2026",
    martirologio_edicion: "Edició",
    buscar_por_nombre: "Cerca per nom",
    sin_resultados: "No s'han trobat resultats.",
    fecha: "Data",
    condicion: "Condició",
    lugar: "Lloc",
    epoca: "Època",
    fuente: "Font",
    ver_catalogo_completo: "Veure el catàleg complet",
    santos_y_beatos: "Sants i beats",
  },
};

const COMMON_FIESTAS_LABELS_BY_LANG_ID: Record<string, Record<string, string>> = {
  "1": {
    "fiestas_titulo": "Comunes",
    "propios_titulo": "Comunes",
    "primeras_visperas": "PRIMERAS VÍSPERAS",
    "oficio_lectura": "OFICIO DE LECTURA",
    "laudes": "LAUDES",
    "horas_intermedias": "HORAS INTERMEDIAS",
    "visperas": "VÍSPERAS",
    "completas": "COMPLETAS",
    "lecturas": "LECTURAS DE LA MISA",
    "structured_option": "Opción",
    "structured_official_variants": "Variantes litúrgicas oficiales",
    "common_variant_default": "Texto general del común",
    "structured_mass": "Misa",
    "structured_entrance_antiphon": "Antífona de entrada",
    "structured_collect": "Oración colecta",
    "structured_prayer_over_offerings": "Oración sobre las ofrendas",
    "structured_preface": "Prefacio",
    "structured_communion_antiphon": "Antífona de comunión",
    "structured_prayer_after_communion": "Oración después de la comunión",
    "structured_lectionary": "Leccionario",
    "structured_first_reading": "Primera lectura",
    "structured_responsorial_psalm": "Salmo responsorial",
    "structured_second_reading": "Segunda lectura",
    "structured_gospel_acclamation": "Aclamación antes del Evangelio",
    "structured_gospel": "Evangelio",
    "structured_liturgy_of_hours": "Liturgia de las Horas",
    "structured_first_vespers": "Primeras Vísperas",
    "structured_office_of_readings": "Oficio de lectura",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermedia",
    "structured_vespers": "Vísperas",
    "common_variant_dedicated_church": "En la iglesia cuya dedicación se celebra",
    "common_variant_outside_dedicated_church": "Fuera de la iglesia dedicada",
    "common_variant_ordinary_time": "Tiempo Ordinario",
    "common_variant_advent": "Tiempo de Adviento",
    "common_variant_christmas": "Tiempo de Navidad",
    "common_variant_easter": "Tiempo Pascual",
    "common_variant_outside_easter_several_martyrs": "Fuera del tiempo pascual — Para varios mártires",
    "common_variant_outside_easter_one_martyr": "Fuera del tiempo pascual — Para un mártir",
    "common_variant_easter_several_martyrs": "Tiempo pascual — Para varios mártires",
    "common_variant_easter_one_martyr": "Tiempo pascual — Para un mártir",
    "common_variant_missionary_several_martyrs": "Para los misioneros mártires — Para varios misioneros mártires",
    "common_variant_missionary_one_martyr": "Para los misioneros mártires — Para un misionero mártir",
    "common_variant_virgin_martyr": "Para una virgen mártir",
    "common_variant_holy_woman_martyr": "Para una santa mujer mártir",
    "common_variant_pope_or_bishop": "Para un Papa o para un obispo",
    "common_variant_bishop": "Para un obispo",
    "common_variant_several_pastors": "Para los pastores — Para varios pastores",
    "common_variant_one_pastor": "Para los pastores — Para un pastor",
    "common_variant_one_founder": "Para los fundadores de las Iglesias — Para un fundador",
    "common_variant_several_founders": "Para los fundadores de las Iglesias — Para varios fundadores",
    "common_variant_missionaries": "Para los misioneros",
    "common_variant_several_virgins": "Para varias vírgenes",
    "common_variant_one_virgin": "Para una virgen",
    "common_variant_all_saints_several": "Para toda clase de santos — Para varios santos",
    "common_variant_all_saints_one": "Para toda clase de santos — Para un santo",
    "common_variant_abbot": "Para los monjes y los religiosos — Para un abad",
    "common_variant_monk": "Para los monjes y los religiosos — Para un monje",
    "common_variant_nun": "Para los monjes y los religiosos — Para una monja",
    "common_variant_religious": "Para los monjes y los religiosos — Para los religiosos",
    "common_variant_works_of_mercy": "Para los que hicieron obras de misericordia",
    "common_variant_educators": "Para los educadores",
    "common_variant_holy_women": "Para las santas mujeres",
    "common_variant_several_martyrs": "Para varios mártires",
    "common_variant_one_martyr": "Para un mártir",
    "common_variant_all_saints": "Para toda clase de santos",
    "common_variant_monks_religious": "Para los monjes y los religiosos",
"common_family_dedication_church": "Común de la dedicación de una iglesia",
"common_family_blessed_virgin_mary": "Común de santa María Virgen",
"common_family_apostles": "Común de apóstoles",
"common_family_martyrs": "Común de mártires",
"common_family_pastors": "Común de pastores",
"common_family_doctors": "Común de doctores de la Iglesia",
"common_family_virgins": "Común de vírgenes",
"common_family_holy_men_women": "Común de santos y santas",
"common_filter_label": "Común",
"common_content_unavailable": "Contenido no disponible en este idioma"
  },
  "4": {
    "fiestas_titulo": "Commons",
    "propios_titulo": "Commons",
    "primeras_visperas": "First Vespers",
    "oficio_lectura": "Office of Readings",
    "laudes": "Lauds",
    "horas_intermedias": "Daytime Prayer",
    "visperas": "Vespers",
    "completas": "Compline",
    "lecturas": "MASS READINGS",
    "structured_option": "Option",
    "structured_official_variants": "Official liturgical variants",
    "common_variant_default": "General text of the Common",
    "structured_mass": "Mass",
    "structured_entrance_antiphon": "Entrance Antiphon",
    "structured_collect": "Collect",
    "structured_prayer_over_offerings": "Prayer over the Offerings",
    "structured_preface": "Preface",
    "structured_communion_antiphon": "Communion Antiphon",
    "structured_prayer_after_communion": "Prayer after Communion",
    "structured_lectionary": "Lectionary",
    "structured_first_reading": "First Reading",
    "structured_responsorial_psalm": "Responsorial Psalm",
    "structured_second_reading": "Second Reading",
    "structured_gospel_acclamation": "Gospel Acclamation",
    "structured_gospel": "Gospel",
    "structured_liturgy_of_hours": "Liturgy of the Hours",
    "structured_first_vespers": "First Vespers",
    "structured_office_of_readings": "Office of Readings",
    "structured_lauds": "Lauds",
    "structured_midday_prayer": "Daytime Prayer",
    "structured_vespers": "Vespers",
    "common_variant_dedicated_church": "In the church whose dedication is celebrated",
    "common_variant_outside_dedicated_church": "Outside the dedicated church",
    "common_variant_ordinary_time": "Ordinary Time",
    "common_variant_advent": "Advent",
    "common_variant_christmas": "Christmas",
    "common_variant_easter": "Easter Time",
    "common_variant_outside_easter_several_martyrs": "Outside Easter Time — For several martyrs",
    "common_variant_outside_easter_one_martyr": "Outside Easter Time — For one martyr",
    "common_variant_easter_several_martyrs": "Easter Time — For several martyrs",
    "common_variant_easter_one_martyr": "Easter Time — For one martyr",
    "common_variant_missionary_several_martyrs": "For missionary martyrs — For several missionary martyrs",
    "common_variant_missionary_one_martyr": "For missionary martyrs — For one missionary martyr",
    "common_variant_virgin_martyr": "For a virgin martyr",
    "common_variant_holy_woman_martyr": "For a holy woman martyr",
    "common_variant_pope_or_bishop": "For a Pope or a bishop",
    "common_variant_bishop": "For a bishop",
    "common_variant_several_pastors": "For pastors — For several pastors",
    "common_variant_one_pastor": "For pastors — For one pastor",
    "common_variant_one_founder": "For founders of Churches — For one founder",
    "common_variant_several_founders": "For founders of Churches — For several founders",
    "common_variant_missionaries": "For missionaries",
    "common_variant_several_virgins": "For several virgins",
    "common_variant_one_virgin": "For one virgin",
    "common_variant_all_saints_several": "For holy men and women — For several saints",
    "common_variant_all_saints_one": "For holy men and women — For one saint",
    "common_variant_abbot": "For monks and religious — For an abbot",
    "common_variant_monk": "For monks and religious — For a monk",
    "common_variant_nun": "For monks and religious — For a nun",
    "common_variant_religious": "For monks and religious — For religious",
    "common_variant_works_of_mercy": "For those who practiced works of mercy",
    "common_variant_educators": "For educators",
    "common_variant_holy_women": "For holy women",
    "common_variant_several_martyrs": "For several martyrs",
    "common_variant_one_martyr": "For one martyr",
    "common_variant_all_saints": "For holy men and women",
    "common_variant_monks_religious": "For monks and religious",
"common_family_dedication_church": "Common of the Dedication of a Church",
"common_family_blessed_virgin_mary": "Common of the Blessed Virgin Mary",
"common_family_apostles": "Common of Apostles",
"common_family_martyrs": "Common of Martyrs",
"common_family_pastors": "Common of Pastors",
"common_family_doctors": "Common of Doctors of the Church",
"common_family_virgins": "Common of Virgins",
"common_family_holy_men_women": "Common of Holy Men and Women",
"common_filter_label": "Common",
"common_content_unavailable": "Content is not available in this language"
  },
  "5": {
    "fiestas_titulo": "Comuni",
    "propios_titulo": "Comuni",
    "primeras_visperas": "Primi Vespri",
    "oficio_lectura": "Ufficio delle letture",
    "laudes": "Lodi mattutine",
    "horas_intermedias": "Ora media",
    "visperas": "Vespri",
    "completas": "Compieta",
    "lecturas": "LETTURE DELLA MESSA",
    "structured_option": "Opzione",
    "structured_official_variants": "Varianti liturgiche ufficiali",
    "common_variant_default": "Testo generale del Comune",
    "structured_mass": "Messa",
    "structured_entrance_antiphon": "Antifona d'ingresso",
    "structured_collect": "Colletta",
    "structured_prayer_over_offerings": "Preghiera sulle offerte",
    "structured_preface": "Prefazio",
    "structured_communion_antiphon": "Antifona alla comunione",
    "structured_prayer_after_communion": "Preghiera dopo la comunione",
    "structured_lectionary": "Lezionario",
    "structured_first_reading": "Prima lettura",
    "structured_responsorial_psalm": "Salmo responsoriale",
    "structured_second_reading": "Seconda lettura",
    "structured_gospel_acclamation": "Acclamazione al Vangelo",
    "structured_gospel": "Vangelo",
    "structured_liturgy_of_hours": "Liturgia delle Ore",
    "structured_first_vespers": "Primi Vespri",
    "structured_office_of_readings": "Ufficio delle letture",
    "structured_lauds": "Lodi mattutine",
    "structured_midday_prayer": "Ora media",
    "structured_vespers": "Vespri",
    "common_variant_dedicated_church": "Nella chiesa di cui si celebra la dedicazione",
    "common_variant_outside_dedicated_church": "Fuori della chiesa dedicata",
    "common_variant_ordinary_time": "Tempo Ordinario",
    "common_variant_advent": "Tempo di Avvento",
    "common_variant_christmas": "Tempo di Natale",
    "common_variant_easter": "Tempo Pasquale",
    "common_variant_outside_easter_several_martyrs": "Fuori del Tempo Pasquale — Per più martiri",
    "common_variant_outside_easter_one_martyr": "Fuori del Tempo Pasquale — Per un martire",
    "common_variant_easter_several_martyrs": "Tempo Pasquale — Per più martiri",
    "common_variant_easter_one_martyr": "Tempo Pasquale — Per un martire",
    "common_variant_missionary_several_martyrs": "Per i missionari martiri — Per più missionari martiri",
    "common_variant_missionary_one_martyr": "Per i missionari martiri — Per un missionario martire",
    "common_variant_virgin_martyr": "Per una vergine martire",
    "common_variant_holy_woman_martyr": "Per una santa donna martire",
    "common_variant_pope_or_bishop": "Per un Papa o un vescovo",
    "common_variant_bishop": "Per un vescovo",
    "common_variant_several_pastors": "Per i pastori — Per più pastori",
    "common_variant_one_pastor": "Per i pastori — Per un pastore",
    "common_variant_one_founder": "Per i fondatori delle Chiese — Per un fondatore",
    "common_variant_several_founders": "Per i fondatori delle Chiese — Per più fondatori",
    "common_variant_missionaries": "Per i missionari",
    "common_variant_several_virgins": "Per più vergini",
    "common_variant_one_virgin": "Per una vergine",
    "common_variant_all_saints_several": "Per i santi e le sante — Per più santi",
    "common_variant_all_saints_one": "Per i santi e le sante — Per un santo",
    "common_variant_abbot": "Per i monaci e i religiosi — Per un abate",
    "common_variant_monk": "Per i monaci e i religiosi — Per un monaco",
    "common_variant_nun": "Per i monaci e i religiosi — Per una monaca",
    "common_variant_religious": "Per i monaci e i religiosi — Per i religiosi",
    "common_variant_works_of_mercy": "Per coloro che hanno esercitato opere di misericordia",
    "common_variant_educators": "Per gli educatori",
    "common_variant_holy_women": "Per le sante donne",
    "common_variant_several_martyrs": "Per più martiri",
    "common_variant_one_martyr": "Per un martire",
    "common_variant_all_saints": "Per i santi e le sante",
    "common_variant_monks_religious": "Per i monaci e i religiosi",
"common_family_dedication_church": "Comune della dedicazione di una chiesa",
"common_family_blessed_virgin_mary": "Comune della beata Vergine Maria",
"common_family_apostles": "Comune degli apostoli",
"common_family_martyrs": "Comune dei martiri",
"common_family_pastors": "Comune dei pastori",
"common_family_doctors": "Comune dei dottori della Chiesa",
"common_family_virgins": "Comune delle vergini",
"common_family_holy_men_women": "Comune dei santi e delle sante",
"common_filter_label": "Comune",
"common_content_unavailable": "Contenuto non disponibile in questa lingua"
  },
  "6": {
    "fiestas_titulo": "Comuns",
    "propios_titulo": "Comuns",
    "primeras_visperas": "Primeiras Vésperas",
    "oficio_lectura": "Ofício das Leituras",
    "laudes": "Laudes",
    "horas_intermedias": "Hora Intermédia",
    "visperas": "Vésperas",
    "completas": "Completas",
    "lecturas": "LEITURAS DA MISSA",
    "structured_option": "Opção",
    "structured_official_variants": "Variantes litúrgicas oficiais",
    "common_variant_default": "Texto geral do Comum",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antífona de entrada",
    "structured_collect": "Oração coleta",
    "structured_prayer_over_offerings": "Oração sobre as oferendas",
    "structured_preface": "Prefácio",
    "structured_communion_antiphon": "Antífona da comunhão",
    "structured_prayer_after_communion": "Oração depois da comunhão",
    "structured_lectionary": "Lecionário",
    "structured_first_reading": "Primeira leitura",
    "structured_responsorial_psalm": "Salmo responsorial",
    "structured_second_reading": "Segunda leitura",
    "structured_gospel_acclamation": "Aclamação ao Evangelho",
    "structured_gospel": "Evangelho",
    "structured_liturgy_of_hours": "Liturgia das Horas",
    "structured_first_vespers": "Primeiras Vésperas",
    "structured_office_of_readings": "Ofício das Leituras",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermédia",
    "structured_vespers": "Vésperas",
    "common_variant_dedicated_church": "Na igreja cuja dedicação se celebra",
    "common_variant_outside_dedicated_church": "Fora da igreja dedicada",
    "common_variant_ordinary_time": "Tempo Comum",
    "common_variant_advent": "Tempo do Advento",
    "common_variant_christmas": "Tempo do Natal",
    "common_variant_easter": "Tempo Pascal",
    "common_variant_outside_easter_several_martyrs": "Fora do Tempo Pascal — Para vários mártires",
    "common_variant_outside_easter_one_martyr": "Fora do Tempo Pascal — Para um mártir",
    "common_variant_easter_several_martyrs": "Tempo Pascal — Para vários mártires",
    "common_variant_easter_one_martyr": "Tempo Pascal — Para um mártir",
    "common_variant_missionary_several_martyrs": "Para os missionários mártires — Para vários missionários mártires",
    "common_variant_missionary_one_martyr": "Para os missionários mártires — Para um missionário mártir",
    "common_variant_virgin_martyr": "Para uma virgem mártir",
    "common_variant_holy_woman_martyr": "Para uma santa mulher mártir",
    "common_variant_pope_or_bishop": "Para um Papa ou um bispo",
    "common_variant_bishop": "Para um bispo",
    "common_variant_several_pastors": "Para os pastores — Para vários pastores",
    "common_variant_one_pastor": "Para os pastores — Para um pastor",
    "common_variant_one_founder": "Para os fundadores das Igrejas — Para um fundador",
    "common_variant_several_founders": "Para os fundadores das Igrejas — Para vários fundadores",
    "common_variant_missionaries": "Para os missionários",
    "common_variant_several_virgins": "Para várias virgens",
    "common_variant_one_virgin": "Para uma virgem",
    "common_variant_all_saints_several": "Para santos e santas — Para vários santos",
    "common_variant_all_saints_one": "Para santos e santas — Para um santo",
    "common_variant_abbot": "Para os monges e religiosos — Para um abade",
    "common_variant_monk": "Para os monges e religiosos — Para um monge",
    "common_variant_nun": "Para os monges e religiosos — Para uma monja",
    "common_variant_religious": "Para os monges e religiosos — Para os religiosos",
    "common_variant_works_of_mercy": "Para os que praticaram obras de misericórdia",
    "common_variant_educators": "Para os educadores",
    "common_variant_holy_women": "Para as santas mulheres",
    "common_variant_several_martyrs": "Para vários mártires",
    "common_variant_one_martyr": "Para um mártir",
    "common_variant_all_saints": "Para santos e santas",
    "common_variant_monks_religious": "Para os monges e religiosos",
"common_family_dedication_church": "Comum da dedicação de uma igreja",
"common_family_blessed_virgin_mary": "Comum da Bem-aventurada Virgem Maria",
"common_family_apostles": "Comum dos Apóstolos",
"common_family_martyrs": "Comum dos Mártires",
"common_family_pastors": "Comum dos Pastores",
"common_family_doctors": "Comum dos Doutores da Igreja",
"common_family_virgins": "Comum das Virgens",
"common_family_holy_men_women": "Comum dos Santos e Santas",
"common_filter_label": "Comum",
"common_content_unavailable": "Conteúdo não disponível neste idioma"
  },
  "7": {
    "fiestas_titulo": "Communs",
    "propios_titulo": "Communs",
    "primeras_visperas": "Premières vêpres",
    "oficio_lectura": "Office des lectures",
    "laudes": "Laudes",
    "horas_intermedias": "Heure médiane",
    "visperas": "Vêpres",
    "completas": "Complies",
    "lecturas": "LECTURES DE LA MESSE",
    "structured_option": "Option",
    "structured_official_variants": "Variantes liturgiques officielles",
    "common_variant_default": "Texte général du Commun",
    "structured_mass": "Messe",
    "structured_entrance_antiphon": "Antienne d'ouverture",
    "structured_collect": "Prière d'ouverture",
    "structured_prayer_over_offerings": "Prière sur les offrandes",
    "structured_preface": "Préface",
    "structured_communion_antiphon": "Antienne de la communion",
    "structured_prayer_after_communion": "Prière après la communion",
    "structured_lectionary": "Lectionnaire",
    "structured_first_reading": "Première lecture",
    "structured_responsorial_psalm": "Psaume responsorial",
    "structured_second_reading": "Deuxième lecture",
    "structured_gospel_acclamation": "Acclamation de l'Évangile",
    "structured_gospel": "Évangile",
    "structured_liturgy_of_hours": "Liturgie des Heures",
    "structured_first_vespers": "Premières vêpres",
    "structured_office_of_readings": "Office des lectures",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Heure médiane",
    "structured_vespers": "Vêpres",
    "common_variant_dedicated_church": "Dans l'église dont on célèbre la dédicace",
    "common_variant_outside_dedicated_church": "En dehors de l'église dédiée",
    "common_variant_ordinary_time": "Temps ordinaire",
    "common_variant_advent": "Temps de l'Avent",
    "common_variant_christmas": "Temps de Noël",
    "common_variant_easter": "Temps pascal",
    "common_variant_outside_easter_several_martyrs": "Hors du temps pascal — Pour plusieurs martyrs",
    "common_variant_outside_easter_one_martyr": "Hors du temps pascal — Pour un martyr",
    "common_variant_easter_several_martyrs": "Temps pascal — Pour plusieurs martyrs",
    "common_variant_easter_one_martyr": "Temps pascal — Pour un martyr",
    "common_variant_missionary_several_martyrs": "Pour les missionnaires martyrs — Pour plusieurs missionnaires martyrs",
    "common_variant_missionary_one_martyr": "Pour les missionnaires martyrs — Pour un missionnaire martyr",
    "common_variant_virgin_martyr": "Pour une vierge martyre",
    "common_variant_holy_woman_martyr": "Pour une sainte femme martyre",
    "common_variant_pope_or_bishop": "Pour un Pape ou un évêque",
    "common_variant_bishop": "Pour un évêque",
    "common_variant_several_pastors": "Pour les pasteurs — Pour plusieurs pasteurs",
    "common_variant_one_pastor": "Pour les pasteurs — Pour un pasteur",
    "common_variant_one_founder": "Pour les fondateurs des Églises — Pour un fondateur",
    "common_variant_several_founders": "Pour les fondateurs des Églises — Pour plusieurs fondateurs",
    "common_variant_missionaries": "Pour les missionnaires",
    "common_variant_several_virgins": "Pour plusieurs vierges",
    "common_variant_one_virgin": "Pour une vierge",
    "common_variant_all_saints_several": "Pour les saints et saintes — Pour plusieurs saints",
    "common_variant_all_saints_one": "Pour les saints et saintes — Pour un saint",
    "common_variant_abbot": "Pour les moines et les religieux — Pour un abbé",
    "common_variant_monk": "Pour les moines et les religieux — Pour un moine",
    "common_variant_nun": "Pour les moines et les religieux — Pour une moniale",
    "common_variant_religious": "Pour les moines et les religieux — Pour les religieux",
    "common_variant_works_of_mercy": "Pour ceux qui ont pratiqué les œuvres de miséricorde",
    "common_variant_educators": "Pour les éducateurs",
    "common_variant_holy_women": "Pour les saintes femmes",
    "common_variant_several_martyrs": "Pour plusieurs martyrs",
    "common_variant_one_martyr": "Pour un martyr",
    "common_variant_all_saints": "Pour les saints et saintes",
    "common_variant_monks_religious": "Pour les moines et les religieux",
"common_family_dedication_church": "Commun de la dédicace d'une église",
"common_family_blessed_virgin_mary": "Commun de la bienheureuse Vierge Marie",
"common_family_apostles": "Commun des Apôtres",
"common_family_martyrs": "Commun des Martyrs",
"common_family_pastors": "Commun des Pasteurs",
"common_family_doctors": "Commun des Docteurs de l'Église",
"common_family_virgins": "Commun des Vierges",
"common_family_holy_men_women": "Commun des Saints et Saintes",
"common_filter_label": "Commun",
"common_content_unavailable": "Contenu non disponible dans cette langue"
  },
  "9": {
    "fiestas_titulo": "Comuns",
    "propios_titulo": "Comuns",
    "primeras_visperas": "Primeres vespres",
    "oficio_lectura": "Ofici de lectura",
    "laudes": "Laudes",
    "horas_intermedias": "Hora intermèdia",
    "visperas": "Vespres",
    "completas": "Completes",
    "lecturas": "LECTURES DE LA MISSA",
    "structured_option": "Opció",
    "structured_official_variants": "Variants litúrgiques oficials",
    "common_variant_default": "Text general del Comú",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antífona d'entrada",
    "structured_collect": "Oració col·lecta",
    "structured_prayer_over_offerings": "Oració sobre les ofrenes",
    "structured_preface": "Prefaci",
    "structured_communion_antiphon": "Antífona de comunió",
    "structured_prayer_after_communion": "Oració després de la comunió",
    "structured_lectionary": "Leccionari",
    "structured_first_reading": "Primera lectura",
    "structured_responsorial_psalm": "Salm responsorial",
    "structured_second_reading": "Segona lectura",
    "structured_gospel_acclamation": "Aclamació abans de l'Evangeli",
    "structured_gospel": "Evangeli",
    "structured_liturgy_of_hours": "Litúrgia de les Hores",
    "structured_first_vespers": "Primeres vespres",
    "structured_office_of_readings": "Ofici de lectura",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermèdia",
    "structured_vespers": "Vespres",
    "common_variant_dedicated_church": "A l'església de la qual se celebra la dedicació",
    "common_variant_outside_dedicated_church": "Fora de l'església dedicada",
    "common_variant_ordinary_time": "Temps de durant l'any",
    "common_variant_advent": "Temps d'Advent",
    "common_variant_christmas": "Temps de Nadal",
    "common_variant_easter": "Temps pasqual",
    "common_variant_outside_easter_several_martyrs": "Fora del temps pasqual — Per a diversos màrtirs",
    "common_variant_outside_easter_one_martyr": "Fora del temps pasqual — Per a un màrtir",
    "common_variant_easter_several_martyrs": "Temps pasqual — Per a diversos màrtirs",
    "common_variant_easter_one_martyr": "Temps pasqual — Per a un màrtir",
    "common_variant_missionary_several_martyrs": "Per als missioners màrtirs — Per a diversos missioners màrtirs",
    "common_variant_missionary_one_martyr": "Per als missioners màrtirs — Per a un missioner màrtir",
    "common_variant_virgin_martyr": "Per a una verge màrtir",
    "common_variant_holy_woman_martyr": "Per a una dona santa màrtir",
    "common_variant_pope_or_bishop": "Per a un Papa o un bisbe",
    "common_variant_bishop": "Per a un bisbe",
    "common_variant_several_pastors": "Per als pastors — Per a diversos pastors",
    "common_variant_one_pastor": "Per als pastors — Per a un pastor",
    "common_variant_one_founder": "Per als fundadors de les Esglésies — Per a un fundador",
    "common_variant_several_founders": "Per als fundadors de les Esglésies — Per a diversos fundadors",
    "common_variant_missionaries": "Per als missioners",
    "common_variant_several_virgins": "Per a diverses verges",
    "common_variant_one_virgin": "Per a una verge",
    "common_variant_all_saints_several": "Per a tota mena de sants — Per a diversos sants",
    "common_variant_all_saints_one": "Per a tota mena de sants — Per a un sant",
    "common_variant_abbot": "Per als monjos i religiosos — Per a un abat",
    "common_variant_monk": "Per als monjos i religiosos — Per a un monjo",
    "common_variant_nun": "Per als monjos i religiosos — Per a una monja",
    "common_variant_religious": "Per als monjos i religiosos — Per als religiosos",
    "common_variant_works_of_mercy": "Per als qui han practicat obres de misericòrdia",
    "common_variant_educators": "Per als educadors",
    "common_variant_holy_women": "Per a les dones santes",
    "common_variant_several_martyrs": "Per a diversos màrtirs",
    "common_variant_one_martyr": "Per a un màrtir",
    "common_variant_all_saints": "Per a tota mena de sants",
    "common_variant_monks_religious": "Per als monjos i religiosos",
"common_family_dedication_church": "Comú de la dedicació d'una església",
"common_family_blessed_virgin_mary": "Comú de santa Maria Verge",
"common_family_apostles": "Comú dels apòstols",
"common_family_martyrs": "Comú dels màrtirs",
"common_family_pastors": "Comú dels pastors",
"common_family_doctors": "Comú dels doctors de l'Església",
"common_family_virgins": "Comú de verges",
"common_family_holy_men_women": "Comú de sants i santes",
"common_filter_label": "Comú",
"common_content_unavailable": "Contingut no disponible en aquesta llengua"
  },
  "10": {
    "fiestas_titulo": "Communia",
    "propios_titulo": "Communia",
    "primeras_visperas": "I Vesperae",
    "oficio_lectura": "Officium lectionis",
    "laudes": "Laudes matutinae",
    "horas_intermedias": "Hora media",
    "visperas": "Vesperae",
    "completas": "Completorium",
    "lecturas": "LECTIONES MISSAE",
    "structured_option": "Optio",
    "structured_official_variants": "Variationes liturgicae officiales",
    "common_variant_default": "Textus generalis Communis",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antiphona ad introitum",
    "structured_collect": "Collecta",
    "structured_prayer_over_offerings": "Super oblata",
    "structured_preface": "Praefatio",
    "structured_communion_antiphon": "Antiphona ad communionem",
    "structured_prayer_after_communion": "Post communionem",
    "structured_lectionary": "Lectionarium",
    "structured_first_reading": "Lectio prima",
    "structured_responsorial_psalm": "Psalmus responsorius",
    "structured_second_reading": "Lectio secunda",
    "structured_gospel_acclamation": "Acclamatio ante Evangelium",
    "structured_gospel": "Evangelium",
    "structured_liturgy_of_hours": "Liturgia Horarum",
    "structured_first_vespers": "I Vesperae",
    "structured_office_of_readings": "Officium lectionis",
    "structured_lauds": "Laudes matutinae",
    "structured_midday_prayer": "Hora media",
    "structured_vespers": "Vesperae",
    "common_variant_dedicated_church": "In ecclesia cuius dedicatio celebratur",
    "common_variant_outside_dedicated_church": "Extra ecclesiam dedicatam",
    "common_variant_ordinary_time": "Tempus per annum",
    "common_variant_advent": "Tempus Adventus",
    "common_variant_christmas": "Tempus Nativitatis",
    "common_variant_easter": "Tempus paschale",
    "common_variant_outside_easter_several_martyrs": "Extra tempus paschale — Pro pluribus martyribus",
    "common_variant_outside_easter_one_martyr": "Extra tempus paschale — Pro uno martyre",
    "common_variant_easter_several_martyrs": "Tempus paschale — Pro pluribus martyribus",
    "common_variant_easter_one_martyr": "Tempus paschale — Pro uno martyre",
    "common_variant_missionary_several_martyrs": "Pro missionariis martyribus — Pro pluribus missionariis martyribus",
    "common_variant_missionary_one_martyr": "Pro missionariis martyribus — Pro uno missionario martyre",
    "common_variant_virgin_martyr": "Pro virgine martyre",
    "common_variant_holy_woman_martyr": "Pro sancta muliere martyre",
    "common_variant_pope_or_bishop": "Pro Papa vel Episcopo",
    "common_variant_bishop": "Pro Episcopo",
    "common_variant_several_pastors": "Pro pastoribus — Pro pluribus pastoribus",
    "common_variant_one_pastor": "Pro pastoribus — Pro uno pastore",
    "common_variant_one_founder": "Pro fundatoribus Ecclesiarum — Pro uno fundatore",
    "common_variant_several_founders": "Pro fundatoribus Ecclesiarum — Pro pluribus fundatoribus",
    "common_variant_missionaries": "Pro missionariis",
    "common_variant_several_virgins": "Pro pluribus virginibus",
    "common_variant_one_virgin": "Pro una virgine",
    "common_variant_all_saints_several": "Pro omnibus sanctis — Pro pluribus sanctis",
    "common_variant_all_saints_one": "Pro omnibus sanctis — Pro uno sancto",
    "common_variant_abbot": "Pro monachis et religiosis — Pro abbate",
    "common_variant_monk": "Pro monachis et religiosis — Pro monacho",
    "common_variant_nun": "Pro monachis et religiosis — Pro moniali",
    "common_variant_religious": "Pro monachis et religiosis — Pro religiosis",
    "common_variant_works_of_mercy": "Pro iis qui opera misericordiae exercuerunt",
    "common_variant_educators": "Pro educatoribus",
    "common_variant_holy_women": "Pro sanctis mulieribus",
    "common_variant_several_martyrs": "Pro pluribus martyribus",
    "common_variant_one_martyr": "Pro uno martyre",
    "common_variant_all_saints": "Pro omnibus sanctis",
    "common_variant_monks_religious": "Pro monachis et religiosis",
"common_family_dedication_church": "Commune Dedicationis ecclesiae",
"common_family_blessed_virgin_mary": "Commune beatae Mariae Virginis",
"common_family_apostles": "Commune Apostolorum",
"common_family_martyrs": "Commune Martyrum",
"common_family_pastors": "Commune Pastorum",
"common_family_doctors": "Commune Doctorum Ecclesiae",
"common_family_virgins": "Commune Virginum",
"common_family_holy_men_women": "Commune Sanctorum et Sanctarum",
"common_filter_label": "Commune",
"common_content_unavailable": "Textus hoc sermone nondum adest"
  }
};

const mergeLabelsWithDefaults = (labels: Labels | null | undefined): Labels => {
  const source = labels || ({} as Labels);
  const merged: any = { ...DEFAULT_LABELS };

  Object.entries(source as any).forEach(([moduleKey, moduleLabels]) => {
    if (moduleLabels && typeof moduleLabels === 'object') {
      merged[moduleKey] = {
        ...((DEFAULT_LABELS as any)[moduleKey] || {}),
        ...(moduleLabels as any),
      };
    }
  });

  return merged as Labels;
};

const LEGACY_COMMON_LABELS_BY_LANG_ID: Record<string, string[]> = {
  "1": ["Propios"],
  "4": ["Proper", "Propers", "Proper Texts"],
  "5": ["Propri", "Testi propri"],
  "6": ["Próprios", "Proprios", "Textos próprios", "Textos proprios"],
  "7": ["Propres", "Textes propres"],
  "9": ["Propis", "Textos propis"],
  "10": ["Propria", "Textus proprii"],
};

const isLegacyCommonLabel = (
  value: string | undefined,
  langId: string
): boolean => {
  if (!value) {
    return false;
  }

  const normalizedValue = String(value).trim().toLocaleLowerCase();
  return (LEGACY_COMMON_LABELS_BY_LANG_ID[langId] || []).some(
    legacyValue => legacyValue.toLocaleLowerCase() === normalizedValue
  );
};

const applyCanonicalCommonLabels = (labels: Labels, lang_id: string): Labels => {
  const canonicalFiestas = COMMON_FIESTAS_LABELS_BY_LANG_ID[lang_id];
  if (!canonicalFiestas) {
    return labels;
  }

  const spanishFiestas = COMMON_FIESTAS_LABELS_BY_LANG_ID['1'] || {};
  const existingFiestas = (labels.fiestas || {}) as Record<string, string | undefined>;
  const mergedFiestas: Record<string, string | undefined> = {
    ...existingFiestas,
  };

  Object.entries(canonicalFiestas).forEach(([key, translatedValue]) => {
    const currentValue = existingFiestas[key];
    const spanishValue = spanishFiestas[key];

    if (
      !currentValue
      || String(currentValue).trim() === ''
      || ((key === 'fiestas_titulo' || key === 'propios_titulo')
        && isLegacyCommonLabel(currentValue, lang_id))
      || (lang_id !== '1' && currentValue === spanishValue)
    ) {
      mergedFiestas[key] = translatedValue;
    }
  });

  const existingHome = (labels.home || {}) as Record<string, string | undefined>;
  const mergedHome: Record<string, string | undefined> = {
    ...existingHome,
  };
  const currentHomeCommon = existingHome.propios;
  const spanishHomeCommon = spanishFiestas.propios_titulo;

  if (
    !currentHomeCommon
    || String(currentHomeCommon).trim() === ''
    || isLegacyCommonLabel(currentHomeCommon, lang_id)
    || (lang_id !== '1' && currentHomeCommon === spanishHomeCommon)
  ) {
    mergedHome.propios = canonicalFiestas.propios_titulo;
  }

  return {
    ...labels,
    home: mergedHome as any,
    fiestas: mergedFiestas,
  };
};

// Función para cargar los labels desde la API y guardarlos en localStorage
export const loadLabels = async (lang_id: string): Promise<Labels> => {
  try {
    const response = await axios.get(ProjectConfig.api_url, {
      params: {
        request: 'lang_labels',
        lang_id: lang_id,
      },
    });

    if (response.data) {
      const editableLabels = mergeLabelsWithDefaults(response.data);
      const normalizedLabels = applyCanonicalCommonLabels(editableLabels, lang_id);
      localStorage.setItem('labels', JSON.stringify(normalizedLabels));
      return normalizedLabels;
    }
  } catch (error) {
    console.error('Error loading labels:', error);
  }

  // Fallback seguro: interfaz base + etiquetas canónicas del idioma.
  const fallbackLabels = applyCanonicalCommonLabels(
    mergeLabelsWithDefaults(DEFAULT_LABELS),
    lang_id
  );
  localStorage.setItem('labels', JSON.stringify(fallbackLabels));
  return fallbackLabels;
};

// Función para obtener un label específico
export const getLabel = (module: string, key: string): string => {
  const labelsStr = localStorage.getItem('labels');
  
  if (labelsStr) {
    try {
      const labels = JSON.parse(labelsStr);
      const moduleLabels = labels[module];
      if (moduleLabels && moduleLabels[key]) {
        return moduleLabels[key];
      }
    } catch (e) {
      console.error('Error parsing labels:', e);
    }
  }

  // Fallback a default
  const defaultModule = DEFAULT_LABELS[module as keyof Labels];
  if (defaultModule) {
    return (defaultModule as any)[key] || key.toUpperCase().replace(/_/g, ' ');
  }

  return key.toUpperCase().replace(/_/g, ' ');
};

const MARTYROLOGY_DESIGNATION_BY_LANG_ID: Record<string, Record<string, string>> = {
  "1": {
    saint: "Santo",
    saints: "Santos",
    blessed: "Beato",
    sanctus: "Santo",
    marian_celebration: "Celebración mariana",
  },
  "4": {
    saint: "Saint",
    saints: "Saints",
    blessed: "Blessed",
    sanctus: "Saint",
    marian_celebration: "Marian celebration",
  },
  "5": {
    saint: "Santo",
    saints: "Santi",
    blessed: "Beato",
    sanctus: "Santo",
    marian_celebration: "Celebrazione mariana",
  },
  "6": {
    saint: "Santo",
    saints: "Santos",
    blessed: "Beato",
    sanctus: "Santo",
    marian_celebration: "Celebração mariana",
  },
  "7": {
    saint: "Saint",
    saints: "Saints",
    blessed: "Bienheureux",
    sanctus: "Saint",
    marian_celebration: "Célébration mariale",
  },
  "10": {
    saint: "Sanctus",
    saints: "Sancti",
    blessed: "Beatus",
    sanctus: "Sanctus",
    marian_celebration: "Celebratio Mariana",
  },
  "9": {
    saint: "Sant",
    saints: "Sants",
    blessed: "Beat",
    sanctus: "Sant",
    marian_celebration: "Celebració mariana",
  },
};

export const getMartyrologyDesignationLabel = (value?: string | null): string => {
  if (!value) return "";
  const currentLangId = localStorage.getItem('lang_id') || '1';
  const normalized = value.trim().toLowerCase();
  return MARTYROLOGY_DESIGNATION_BY_LANG_ID[currentLangId]?.[normalized]
    || MARTYROLOGY_DESIGNATION_BY_LANG_ID['1']?.[normalized]
    || value.replace(/_/g, ' ');
};

// Función helper específica para santoral
export const getSantoralLabel = (key: string): string => {
  const currentLangId = localStorage.getItem('lang_id') || '1';
  const raw = getLabel('santoral', key);
  const canonical = SANTORAL_NAV_LABELS_BY_LANG_ID[currentLangId]?.[key];
  const spanish = SANTORAL_NAV_LABELS_BY_LANG_ID['1']?.[key];
  const generatedFallback = key.toUpperCase().replace(/_/g, ' ');

  if (
    canonical
    && (
      !raw
      || raw === generatedFallback
      || (currentLangId !== '1' && raw === spanish)
      || (key === 'santoral_titulo' && ['santoral', 'sanctoral'].includes(raw.trim().toLowerCase()))
    )
  ) {
    return canonical;
  }

  return raw;
};

// Función helper específica para home
export const getHomeLabel = (key: string): string => {
  const currentLangId = localStorage.getItem('lang_id') || '1';
  const raw = getLabel('home', key);

  if (key === 'propios') {
    const canonical = COMMON_FIESTAS_LABELS_BY_LANG_ID[currentLangId]?.propios_titulo;
    const spanish = COMMON_FIESTAS_LABELS_BY_LANG_ID['1']?.propios_titulo;
    if (
      canonical
      && (
        !raw
        || isLegacyCommonLabel(raw, currentLangId)
        || (currentLangId !== '1' && raw === spanish)
      )
    ) {
      return canonical;
    }
  }

  return raw;
};

// Función helper específica para aniversarios
export const getAniversariosLabel = (key: string): string => {
  return getLabel('aniversarios', key);
};

// Función helper específica para fiestas
export const getFiestasLabel = (key: string): string => {
  const currentLangId = localStorage.getItem('lang_id') || '1';
  const raw = getLabel('fiestas', key);
  const canonical = COMMON_FIESTAS_LABELS_BY_LANG_ID[currentLangId]?.[key];
  const spanish = COMMON_FIESTAS_LABELS_BY_LANG_ID['1']?.[key];
  const generatedFallback = key.toUpperCase().replace(/_/g, ' ');

  if (
    canonical
    && (
      !raw
      || raw === generatedFallback
      || (currentLangId !== '1' && raw === spanish)
      || (
        (key === 'fiestas_titulo' || key === 'propios_titulo')
        && isLegacyCommonLabel(raw, currentLangId)
      )
    )
  ) {
    return canonical;
  }

  return raw;
};

// Función helper específica para maximas
export const getMaximasLabel = (key: string): string => {
  return getLabel('maximas', key);
};

// Función helper específica para oraciones
export const getOracionesLabel = (key: string): string => {
  return getLabel('oraciones', key);
};

// Función helper específica para multimedia
export const getMultimediaLabel = (labels: Labels, key: string): string => {
  if (labels?.multimedia && (labels.multimedia as any)[key]) {
    return (labels.multimedia as any)[key];
  }
  return DEFAULT_LABELS.multimedia?.[key as keyof typeof DEFAULT_LABELS.multimedia] || key.toUpperCase().replace(/_/g, ' ');
};

// Función helper específica para acuerdos
export const getAcuerdosLabel = (key: string): string => {
  return getLabel('acuerdos', key);
};

// Función helper específica para directorio
export const getDirectorioLabel = (key: string): string => {
  return getLabel('directorio', key);
};

// Función helper específica para constituciones
export const getConstitucionesLabel = (key: string): string => {
  return getLabel('constituciones', key);
};

// Función helper específica para celebraciones
export const getCelebracionesLabel = (key: string): string => {
  return getLabel('celebraciones', key);
};

// Función helper específica para calendario litúrgico
export const getCalendarioLiturgicoLabel = (key: string): string => {
  return getLabel('calendario_liturgico', key);
};

// Función helper específica para sistema
export const getSistemaLabel = (key: string): string => {
  return getLabel('sistema', key);
};

// Hook para cargar y usar labels
export const useLabels = () => {
  const labelsStr = localStorage.getItem('labels');
  let labels: Labels = DEFAULT_LABELS;
  
  if (labelsStr) {
    try {
      labels = JSON.parse(labelsStr);
    } catch (e) {
      console.error('Error parsing labels:', e);
    }
  }
  
  return { labels };
};

